<p>
  promotions works!
</p>
